import { CreativeStatusEnum, DLCEnum, StatusInvoiceEnum } from './data';

export const generateColor = (numberItem) => {
  let listColor = [];
  for (let i = 0; i < numberItem; i++) {
    listColor = [...listColor, `hsl(${(i * (360 / numberItem)) % 360}, 100%, 50%)`];
  }

  return listColor;
};

export const colorChartDid = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
};

export const colorChartImport = {
  dnc: '#46BDC6',
  landline: '#4284F4',
  imported: '#FF6D02',
  listColor: (numberItem) => generateColor(numberItem),
};

export const genColorStatus = (status) => {
  if ([DLCEnum.status.COMPLETED, DLCEnum.status.ACTIVE].includes(status)) {
    return 'success';
  }

  if (
    [DLCEnum.status.FAILED, DLCEnum.status.DEACTIVATED, DLCEnum.status.EXPIRED].includes(status)
  ) {
    return 'danger';
  }

  return 'pending';
};

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const genStatusInvoiceColor = (status) => {
  if (['succeeded', StatusInvoiceEnum.Succeeded].includes(status)) {
    return 'success';
  }

  if (['failed', StatusInvoiceEnum.Failed].includes(status)) {
    return 'danger';
  }

  if ([StatusInvoiceEnum.WaitPayment].includes(status)) {
    return 'pending';
  }

  return 'processing';
};

export const genStatusProcessBadgeColor = (status) => {
  const colors = {
    COMPLETED: 'success',
    SUCCESSFUL: 'success',
    STOPPED: 'danger',
    ERROR: 'danger',
    CRASH: 'danger',
    PAUSED: 'danger',
    PAUSED_SYSTEM_MAINTENANCE: 'danger',
    DISTRIBUTED: 'primary',
    MAINTAIN: 'primary',
    INIT: 'black',
    RUNNING: 'primary',
  };

  return colors?.[status] || 'secondary';
};

export const genColorStatusCreative = (status) => {
  const result = {
    [CreativeStatusEnum.APPROVED]: 'success',
    [CreativeStatusEnum.PENDING]: 'pending',
    [CreativeStatusEnum.REJECTED]: 'danger',
  };

  return result?.[status] || '';
};

export const genColorByNumber = (number) => {
  return '#' + Math.floor((number / 12) * 16777215).toString(16);
};

export function stringToColor(str) {
  // Hash function to convert string to a number
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Convert the number to a hex color code
  let color = '#';
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).substr(-2);
  }
  return color;
}

export const genBadgeColorByCommonStatus = (status) => {
  const mapping = {
    RUNNING: 'primary',
    PENDING: 'primary',
    APPROVED: 'success',
    REJECTED: 'danger',
    COMPLETED: 'success',

    RELEASED: 'success',
    ERROR: 'danger',
    FAILED: 'danger',
    ROLLBACK: 'danger',
    PAUSED: 'danger',
    RELEASING: 'warning',
    ROLLING_BACK: 'warning',
  };

  return mapping?.[status] || '';
};
